import React from 'react';
import { Card, Form, Input, Button } from 'antd';
import CountDown from 'components/ant-design-pro/CountDown';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { formItemLayout } from 'utils/utils.js';
import moment from 'moment';
import { stringify } from 'qs';
import styles from './Index.less';

const FormItem = Form.Item;

@connect(({ user, loading, operationChargeItemPublishChargeItemSteps }) => ({
  showCountDown: operationChargeItemPublishChargeItemSteps.showCountDown,
  mobile: user.currentUser.mobile,
  loadingSendCode: loading.effects['operationChargeItemPublishChargeItemSteps/sendCode'],
  publishSchool: operationChargeItemPublishChargeItemSteps.publishSchool,
  payAppId: operationChargeItemPublishChargeItemSteps.validateResult.payAppId,
  selectedRowKeys: operationChargeItemPublishChargeItemSteps.selectedRowKeys,
  submitting: loading.effects['operationChargeItemPublishChargeItemSteps/publish'],
  chargeItemFormValues: operationChargeItemPublishChargeItemSteps.chargeItemFormValues,
  publishResult: operationChargeItemPublishChargeItemSteps.publishResult,
  chargeItemTarget: operationChargeItemPublishChargeItemSteps.step3NotificationChargeItemTarget,
  tableDataSource: operationChargeItemPublishChargeItemSteps.step3NotificationTableDataSource,
  addressBook: operationChargeItemPublishChargeItemSteps.addressBook,
}))
@Form.create()
export default class Step4 extends React.Component {
  constructor(props) {
    super(props);

    this.handlePrevStep = this.handlePrevStep.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSendCode = this.handleSendCode.bind(this);
    this.renderSendCode = this.renderSendCode.bind(this);
    this.renderSendCodeButton = this.renderSendCodeButton.bind(this);
    this.getAddressDetail = this.getAddressDetail.bind(this);
  }

  getAddressDetail() {
    const { selectedRowKeys, addressBook } = this.props;
    const { tableList } = addressBook;
    const resultList = [];
    const commodityList = [];

    selectedRowKeys.forEach(item => {
      commodityList.push({
        commodityId: item,
        commoditySkuId: '',
      });
    });

    tableList.forEach(item => {
      const parentIdLength = item.parentId.length;
      const gradeIdIndex = parentIdLength >= 2 ? parentIdLength - 2 : parentIdLength - 1;
      const orgStructIdIndex = parentIdLength - 1;

      resultList.push({
        userId: item.id,
        userName: item.name,
        groupType: item.groupType,
        gradeName: item.lastDepartName,
        gradeId: item.parentId[gradeIdIndex], // 用户上级部门（所在年级）id
        className: item.curDepartName,
        orgStructId: item.parentId[orgStructIdIndex],
        commodities: commodityList,
      });
    });

    return resultList;
  }

  handlePrevStep() {
    this.props.dispatch({ type: 'operationChargeItemPublishChargeItemSteps/decrementCurrentStep' });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { form, dispatch, chargeItemFormValues } = this.props;

    form.validateFields((err, values) => {
      if (!err) {
        const {
          payAppId,
          selectedRowKeys,
          chargeItemTarget,
          tableDataSource,
          publishSchool,
        } = this.props;

        const gmtBegin = moment(
          `${chargeItemFormValues.time[0].format(
            'YYYY-MM-DD'
          )} ${chargeItemFormValues.gmtBeginTime.format('HH:mm:ss')}`
        ).format('x');

        const gmtEnd = moment(
          `${chargeItemFormValues.time[1].format(
            'YYYY-MM-DD'
          )} ${chargeItemFormValues.gmtEndTime.format('HH:mm:ss')}`
        ).format('x');

        const details =
          chargeItemTarget === 'fromUploadExcel' ? tableDataSource : this.getAddressDetail();

        dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/publish',
          orgId: publishSchool.key,
          orgName: publishSchool.label,
          payAppId,
          commodityIds: selectedRowKeys,
          code: values.code,
          title: chargeItemFormValues.title,
          necessary: chargeItemFormValues.necessary,
          gmtBegin,
          gmtEnd,
          mode: chargeItemFormValues.mode,
          details,
        }).then(({ success }) => {
          if (success) {
            const params = {
              title: chargeItemFormValues.title,
            };

            dispatch(
              routerRedux.replace(
                `/operation/charge-item/publish-success-notification?${stringify(params)}`
              )
            );
          }
        });
      }
    });
  }

  handleSendCode() {
    const { dispatch } = this.props;

    dispatch({ type: 'operationChargeItemPublishChargeItemSteps/sendCode' });
  }

  renderSendCodeButton() {
    const { loadingSendCode, showCountDown } = this.props;

    if (showCountDown) {
      const targetTime = new Date().getTime() + 1000 * 120;
      return (
        <Button type="primary" disabled>
          <CountDown
            target={targetTime}
            onEnd={() => {
              this.props.dispatch({
                type: 'operationChargeItemPublishChargeItemSteps/toggleCountDown',
              });
            }}
            format={time => `${Math.floor(time / 1000)}s`}
          />
        </Button>
      );
    }

    return (
      <Button type="primary" onClick={this.handleSendCode} loading={loadingSendCode}>
        获取验证码
      </Button>
    );
  }

  renderSendCode() {
    return (
      <div className="send-code">
        <Input placeholder="请输入" />
        {this.renderSendCodeButton()}
      </div>
    );
  }

  render() {
    const { mobile, submitting, publishResult } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Card bordered={false} className={styles.root}>
        <Form onSubmit={this.handleSubmit} className={styles.root}>
          <FormItem {...formItemLayout} label="手机号">
            {mobile}
          </FormItem>

          <FormItem {...formItemLayout} label="手机验证码">
            {getFieldDecorator('code', {
              rules: [{ required: true, message: '请输入手机验证码' }],
            })(this.renderSendCode())}
          </FormItem>

          {publishResult.result === false && (
            <FormItem className="error-msg">
              <div>{publishResult.msg}</div>
            </FormItem>
          )}

          <FormItem className="operation-button-wrap">
            <Button onClick={this.handlePrevStep}>上一步</Button>
            <Button type="primary" htmlType="submit" loading={submitting}>
              发布
            </Button>
          </FormItem>
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step4-Notification/Index.js